import React, { useState, useEffect, useRef } from "react";
import { BsArrowLeft, BsArrowClockwise, BsEnvelopeX, BsFillCheckCircleFill, BsHourglassSplit, BsFillExclamationCircleFill } from "react-icons/bs";
import { RxExternalLink } from "react-icons/rx";
import { IoIosAttach, IoMdSend, IoMdTrash } from "react-icons/io";
import ClinicalSide from "./ClinicalSide";
import PatientSide from "./PatientSide";
import ApiService from "../../../../ApiService";
import MaterialTable, { MTableFilterRow } from "material-table";
import { Col, Row, Spinner, Container, Card, OverlayTrigger, Tooltip, Button, Modal, Form } from "react-bootstrap";
import MessageDetail from "../../../../components/MessageDetail";
import moment from "moment";
import { Healing } from "@material-ui/icons";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ERXModal from "../../../Modal/eRx/ERXModal";
import { set } from "lodash";

function formatDate(inputDate) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const date = new Date(inputDate);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date
    .getFullYear()
    .toString()
    .substr(-2);

  return `${day} ${month} '${year}`;
}

export default function PatientMessage({ patientId }) {
  const [messages, setMessages] = useState([]);
  const [messageContent, setMessageContent] = useState("");
  const [closeConvModal, setCloseConvModal] = useState(false);
  const [mode, setMode] = useState(null);
  const [messageUUID, setMessageUUID] = useState(null);
  const [closeConvList, setCloseConvList] = useState(null);
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxid, setERxId] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [closingInfo, setClosingInfo] = useState(null);
  const ref = useRef();
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   ref.current.scrollIntoView({
  //     behavior: "smooth",
  //     block: "nearest",
  //     inline: "start"
  //   });
  // }, []);

  useEffect(() => {
    const fetcher = async () => {
      try {
        setIsLoading(true);
        const response = await ApiService.getPatientInbox(patientId);
        console.log(response?.data);
        setMessages(response?.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetcher();
  }, []);

  const sendMessageAPI = async () => {
    console.log(messageContent);
    try {
      const msg = {
        patientId: patientId,
        base64Message: btoa(encodeURIComponent(messageContent)),
        rawMessage: messageContent,
        attachmentUrls: []
      };
      const postPatientMessage = await ApiService.sendSecureMsgToPatient(msg)
        .then(res => {
          console.log(res);
          setMessages([...messages, res?.data]);
          setMessageContent("");
        })
        .catch(error => {
          const msg = error?.response?.data?.message ?? error?.message;
          console.log(msg);
        });
    } catch (error) {
      const msg = error?.response?.data?.message ?? error?.message;
      console.log(msg);
    }
  };
  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  const handleCloseConvModal = () => {
    setCloseConvModal(false);
  };

  const handleCloseConversations = async (status, reason, loader) => {
    try {
      loader(true);
      if (!status || !reason) return handleSnackOpen("Please enter a reason", "error");
      let msgIds = closeConvList.map(item => item.messageUUID).join(",");
      await ApiService.addAnnotationToMessage({
        comment: reason,
        status: status,
        msgIds
      });
      handleSnackOpen(`Status changed to ${status} successfully`, "success");
      setCloseConvModal(false);
      setCloseConvList(null);
      setMode(null);
      // getMessages();
    } catch (ex) {
      console.log("error", ex);
      handleSnackOpen("Something went wrong", "error");
    } finally {
      loader(false);
    }
  };

  const getStatusColVal = rowData => {
    if (rowData?.latestStatus === "DONE")
      return (
        <span style={{ color: "#266400" }}>
          <b>DONE</b>
        </span>
      );
    if (rowData?.latestStatus === "IN_PROGRESS")
      return (
        <span style={{ color: "#BA8719" }}>
          <b>IN PROGRESS</b>
        </span>
      );
    if (rowData?.latestStatus === "NEEDS_REVIEW")
      return (
        <span style={{ color: "#FA2F2F" }}>
          <b>NEEDS REVIEW</b>
        </span>
      );
    return <span></span>;
  };
  function fetchMessage(messageUUID) {
    setMode("VIEW_MESSAGE_DETAIL");
    setMessageUUID(messageUUID);
    setCloseConvList([{ messageUUID: messageUUID }]);
  }

  const localization = {
    toolbar: {
      nRowsSelected: "{0} conversation(s) selected"
    }
  };
  return (
    <div className=" messageContainer">
      {/* <div className="messageHeader">
        <div className="statusCheck">
          <div>Status: </div>
          <div className="statusChip">
            <BsCheck /> Done
          </div>
        </div>

        <div className="statuses">
          <div className="changeStatusChip">
            Change Status
            <BsArrowClockwise />
          </div>
          <div className="messageStatusChip">
            Go to messaging
            <RxExternalLink />
          </div>
        </div>
      </div> */}
      {/* 
      <div className="mt-2">
        Comment: <strong>Responded by phone on 5/12/22</strong>
      </div> */}

      <div className="messageSection">
        {mode !== "VIEW_MESSAGE_DETAIL" && (
          <>
            {messages?.length ? (
              <MaterialTable
                columns={[
                  {
                    title: "Sender",
                    field: "from"
                  },
                  {
                    title: "Subject",
                    field: "subject",
                    cellStyle: {
                      width: 500,
                      maxWidth: 500
                    }
                  },
                  {
                    title: "Date/Time",
                    field: "createdDateTime",
                    render: rowData => <span>{moment(rowData?.createdDateTime).format("ddd MMM D, YYYY LT")}</span>
                  },
                  // {
                  //   title: "Status",
                  //   field: "latestStatus",
                  //   render: rowData => getStatusColVal(rowData),
                  //   cellStyle: {
                  //     width: 400,
                  //     maxWidth: 400
                  //   }
                  // },
                  // {
                  //   title: "Dob",
                  //   field: "patientDob",
                  //   render: rowData => <span>{rowData?.patientDob}</span>
                  // },
                  // {
                  //   title: "State",
                  //   field: "state",
                  //   render: rowData => <span>{rowData?.state}</span>
                  // },
                  {
                    title: "Recipients",
                    field: "to",
                    render: rowData => <span>{rowData?.to}</span>
                  }
                ]}
                data={messages}
                onRowClick={(event, rowData) => {
                  console.log(rowData?.messageUUID);
                  if (rowData?.unread) {
                    fetchMessage(rowData?.messageUUID);
                    // reduce();
                  } else {
                    fetchMessage(rowData?.messageUUID);
                  }
                }}
                onSelectionChange={rows => {
                  if (rows.length >= 1) {
                    setCloseConvList(rows);
                  } else {
                    setCloseConvList([]);
                  }
                }}
                localization={localization}
                options={{
                  selection: true,
                  selectionProps: rowData => ({
                    disabled: rowData?.repliedBy ? true : false
                  }),
                  filtering: true,
                  exportButton: true,
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    color: "black"
                  },
                  maxBodyHeight: "630px",
                  search: true,
                  pageSize: 100,
                  pageSizeOptions: [50, 100, 200, 500],
                  emptyRowsWhenPaging: false,
                  draggable: false,
                  showTitle: true,
                  toolbarButtonAlignment: "right",
                  exportAllData: true,
                  doubleHorizontalScroll: true,
                  sorting: true,
                  rowStyle: rowData => {
                    const style = {
                      backgroundColor: rowData?.readBy[0] != "null" ? "#e4e4e4" : "#FFFFFF",
                      color: rowData?.unread ? "black" : "black",
                      border: true,
                      fontWeight: rowData?.unread ? "bold" : "normal"
                    };
                    return style;
                  }
                }}
                title="Inbox"
                components={{
                  FilterRow: props => {
                    return <MTableFilterRow {...props} />;
                  }
                }}
              />
            ) : (
              <div className="no-message">{isLoading ? <div className="loading"></div> : <h1 className="noRecordFound">No messages found</h1>}</div>
            )}
          </>
        )}
        {mode === "VIEW_MESSAGE_DETAIL" ? (
          <>
            <Card body className="CardFullBody">
              <Card.Body className="messageDetailBody">
                <Col>
                  <div
                    style={{
                      width: "100%",
                      fontSize: "1vw",
                      display: "inline-flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 6
                    }}
                  >
                    <div>
                      <div style={{ display: "inline-flex", opacity: closingInfo?.latestStatus ? 1 : 0 }}>
                        Status : <StatusDone status={closingInfo?.latestStatus} />
                      </div>
                    </div>
                    <Button
                      variant="primary"
                      style={{
                        width: "auto",
                        height: 35,
                        background: "#007F61",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "bold",
                        border: "none"
                      }}
                      onClick={() => setCloseConvModal(true)}
                    >
                      <BsArrowClockwise />
                      &nbsp;&nbsp;Update Status
                    </Button>
                  </div>
                  <br />
                  {closingInfo && (
                    <Form.Label
                      style={{ width: "100%", fontSize: "1vw", display: "inline-flex", justifyContent: "flex-start", alignItems: "center" }}
                    >
                      <div>
                        Comment :&nbsp;<b>{closingInfo?.latestComment}</b>
                      </div>
                      &nbsp;&nbsp;-&nbsp;&nbsp;
                      <div>
                        Author :&nbsp;<b>{closingInfo?.latestCommentBy}</b>
                      </div>
                    </Form.Label>
                  )}
                  <hr />
                </Col>
                <span className="go-back-wrap" onClick={() => setMode(null)}>
                  <BsArrowLeft />
                </span>
                <MessageDetail messageUUID={messageUUID} setClosingInfo={setClosingInfo} />
              </Card.Body>
            </Card>
            <Snackbar open={snackOpen} autoHideDuration={2500} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <Alert onClose={handleSnackClose} severity={snackSeverity}>
                {snackText}
              </Alert>
            </Snackbar>

            <ConfirmationModal show={closeConvModal} handleClose={handleCloseConvModal} handleConfirm={handleCloseConversations} />
          </>
        ) : (
          <></>
        )}
        {/* {messages?.map((message, index) => {
          if (message.fromField === "PATIENT") {
            return (
              <PatientSide
                key={index}
                date={formatDate(message?.createdDateTime)}
                sub={message?.subject}
                to={message?.to}
                toEmail={message?.toUsers[0]?.email}
                cc={message?.ccToGroupNames}
                ccEmail={""}
                content={message?.content}
              />
            );
          } else if (message.fromField === "CLINICIAN") {
            return (
              <ClinicalSide
                key={index}
                content={message?.content}
                from={message?.fromUser?.firstName + " " + message?.fromUser?.lastName}
                fromEmail={message?.fromUser?.email}
              />
            );
          }
        })}
        <div ref={ref}></div> */}
      </div>

      {/* <div className="messageInputBox">
        <textarea rows={2} placeholder="Write message here" value={messageContent} onChange={e => setMessageContent(e.target.value)} />
        <div className="d-flex justify-content-between">
          <div>
            <IoIosAttach size={20} color="green" />
          </div>
          <div className="d-flex">
            <div>
              <IoMdTrash size={20} color="green" />
            </div>
            <div className="ml-2">
              <IoMdSend
                size={20}
                color="green"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  sendMessageAPI();
                }}
              />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ConfirmationModal = ({ show, handleClose, handleConfirm }) => {
  const [status, setStatus] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  return (
    <Modal show={show} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Body>
        <p>Are you sure want to update status?</p>
        <div key={`default-radio`} className="mb-3">
          <Form.Check
            type={"radio"}
            label={`Needs Review`}
            value="NEEDS_REVIEW"
            checked={status === "NEEDS_REVIEW"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
          <Form.Check
            type={"radio"}
            label={`In Progress`}
            value="IN_PROGRESS"
            checked={status === "IN_PROGRESS"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
          <Form.Check
            type={"radio"}
            label={`Done`}
            value="DONE"
            checked={status === "DONE"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
        </div>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Reason for this status?</Form.Label>
          <Form.Control as="textarea" rows={3} placeholder="Type in the reason" onChange={e => setReason(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="secondary" onClick={handleClose}>
          CLOSE
        </Button>
        <Button
          variant="light"
          disabled={loading}
          style={{
            width: "auto",
            color: "white",
            background: "#007F61",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            border: "none"
          }}
          onClick={() => handleConfirm(status, reason, setLoading)}
        >
          CONFIRM
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
const StatusDone = ({ status }) => {
  return (
    <div
      style={{
        width: "auto",
        height: 30,
        color: "white",
        background: status === "DONE" ? "#007F61" : status === "IN_PROGRESS" ? "#BA8719" : status === "NEEDS_REVIEW" ? "#FA2F2F" : "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        border: "none",
        borderRadius: 5,
        paddingInline: 10,
        fontSize: "1vw",
        marginLeft: 10
      }}
    >
      {status === "DONE" ? (
        <BsFillCheckCircleFill />
      ) : status === "IN_PROGRESS" ? (
        "In Progress"
      ) : status === "NEEDS_REVIEW" ? (
        <BsFillExclamationCircleFill />
      ) : null}
      &nbsp;&nbsp;{status === "DONE" ? "Done" : status === "IN_PROGRESS" ? <BsHourglassSplit /> : status === "NEEDS_REVIEW" ? "Needs Review" : null}
    </div>
  );
};
